// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';

export const nomenclaturesApi = createApi({
    reducerPath: 'nomenclaturesApi',
    baseQuery: baseQuery('public/nomenclatures'),
    endpoints: (builder) => {
        return {
            getProductPdf: builder.query<string, {
                nomenclature_uuid: string;
                univers_uuid: string;
                lang: string;
                produit_uuid: string;
            }>({
                query: ({ nomenclature_uuid, univers_uuid, lang, produit_uuid }) => {
                    return {
                        url: `/${nomenclature_uuid}/pdf?univers_uuid=${univers_uuid}&lang=${lang}&produit_uuid=${produit_uuid}`,
                        method: 'get',
                        headers: {
                            'Content-Type': 'text/plain',
                        },
                        params: {
                            nomenclature_uuid,
                            univers_uuid,
                            produit_uuid,
                            lang,
                        }
                    };
                },
            }),
        };
    },
});

export const { useGetProductPdfQuery, useLazyGetProductPdfQuery } = nomenclaturesApi;
